import httpClient from "./client";

export const createQuestionnaire = async (questionnaireData) => {
  const response = await httpClient.post("/questionnaires/", questionnaireData);
  return response.data;
};

export const createScheduledQuestionnaire = async (questionnaireData) => {
  const response = await httpClient.post(
    "/scheduler/process/job",
    questionnaireData
  );
  return response.data;
};

export const getAllQuestionnaires = async (
  isActive,
  status,
  page,
  pageSize,
  pollDateStart,
  pollDateEnd,
  sortBy,
  sortOrder
) => {
  const response = await httpClient.get("/questionnaires/", {
    params: {
      isActive,
      status,
      page,
      pageSize,
      pollDateStart,
      pollDateEnd,
      sortBy,
      sortOrder,
    },
  });
  return response;
};

export const getQuestionnaireById = async (questionnaireId) => {
  const response = await httpClient.get(`/questionnaires/${questionnaireId}`);
  return response;
};

export const getQuestionnaireAndResponses = async (questionnaireId) => {
  const response = await httpClient.get(
    `/questionnaires/${questionnaireId}/answers-stats`
  );
  return response;
};
